'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var _collections = require('redux/modules/collections');

var collectionActions = _interopRequireWildcard(_collections);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionList = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    if (!setupActions.isSeoLoaded(getState())) {
      promises.push(dispatch(setupActions.loadSeo()));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    collection: state.collections.collection,
    province: state.address.province,
    lists: state.collections.lists,
    total: state.collections.total,
    pageSize: state.collections.pageSize,
    loading: state.collections.loadingDetail,
    loaded: state.collections.loadedDetail
  };
}, (0, _extends3.default)({}, collectionActions)), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(CollectionList, _Component);

  function CollectionList() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CollectionList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = CollectionList.__proto__ || (0, _getPrototypeOf2.default)(CollectionList)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      pageSize: 100,
      lazy: false,
      firstLoad: false,
      sort: ''
    }, _this.handleChangeSortType = function (event) {
      _this.setState({ sort: event.target.value });
      var filter = {
        province: _this.props.province,
        pageSize: _this.state.pageSize,
        sort: event.target.value
      };
      _this.props.load(filter);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CollectionList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.loaded && this.props.loading !== true || !this.props.lists || !this.state.firstLoad) {
        this.getResult.call(this);
      }
      document.addEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.loading) {
        this.setState({ firstLoad: true });
      }
      if (nextProps.pageSize !== this.props.pageSize) {
        this.setState({ pageSize: nextProps.pageSize });
      }
      if (!nextProps.loading) {
        this.setState({ lazy: false });
      }
      if (nextProps.province !== this.props.province) {
        this.getResult.call(this);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'getResult',
    value: function getResult() {
      var filter = {
        province: this.props.province,
        pageSize: this.state.pageSize,
        sort: this.state.sort
      };
      this.props.load(filter);
    }
  }, {
    key: 'isBottom',
    value: function isBottom(el) {
      return el.getBoundingClientRect().bottom <= window.innerHeight;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./CollectionDetail.scss');
      var _props = this.props,
          lists = _props.lists,
          total = _props.total;
      var _state = this.state,
          sort = _state.sort,
          pageSize = _state.pageSize,
          lazy = _state.lazy;

      return _react2.default.createElement(
        'div',
        { className: styles.collectionDetail + ' container' },
        _react2.default.createElement(_components.HelmetSEO, { path: 'bo-suu-tap' }),
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement('div', { className: styles.borderHighlight }),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            'B\u1ED9 s\u01B0u t\u1EADp'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.headerRight },
            _react2.default.createElement(
              'div',
              { className: styles.rightTab },
              _react2.default.createElement(
                'div',
                { className: styles.numberShop },
                _react2.default.createElement(
                  'span',
                  { className: styles.number },
                  total || 0
                ),
                ' b\u1ED9 s\u01B0u t\u1EADp'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.order },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'order' },
                  'S\u1EAFp x\u1EBFp'
                ),
                _react2.default.createElement(
                  'select',
                  {
                    name: 'order',
                    id: 'order',
                    className: styles.select,
                    value: sort,
                    onChange: function onChange(event) {
                      return _this2.handleChangeSortType(event);
                    }
                  },
                  _react2.default.createElement(
                    'option',
                    { value: 'createdAt' },
                    'M\u1EDBi nh\u1EA5t'
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 'suggest' },
                    '\u0110\u1ECBa \u0111i\u1EC3m g\u1EE3i \xFD'
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 'total_like' },
                    'Nhi\u1EC1u like nh\u1EA5t'
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 'total_view' },
                    'Nhi\u1EC1u view nh\u1EA5t'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.listCollection },
          _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            lists && lists.map(function (collection, index) {
              return _react2.default.createElement(
                _reactBootstrap.Col,
                { md: 3, key: index },
                _react2.default.createElement(_components.CollectionCard, { item: collection })
              );
            })
          ),
          _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            pageSize <= total && lazy ? _react2.default.createElement('div', { className: styles.lazyLoad }) : _react2.default.createElement(
              'p',
              { className: styles.endResult },
              '----- End Results -----'
            )
          )
        )
      );
    }
  }]);
  return CollectionList;
}(_react.Component), _class2.propTypes = {
  params: _react.PropTypes.object,
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  load: _react.PropTypes.func.isRequired,
  collection: _react.PropTypes.object,
  getOneByHandle: _react.PropTypes.func.isRequired,
  total: _react.PropTypes.number,
  pageSize: _react.PropTypes.number,
  lists: _react.PropTypes.array,
  province: _react.PropTypes.string
}, _temp2)) || _class) || _class);
exports.default = CollectionList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Collection/CollectionList.js
// module id = 1664
// module chunks = 0